type FormSingleColumnWithDropShadowProps = {
  children: React.ReactNode;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
};

export const FormSingleColumn = ({ children, onSubmit }: FormSingleColumnWithDropShadowProps) => {
  return (
    // noValidate prevents browser native validation so react-hook-form error UI is shown instead
    <form id="createPipelineForm" onSubmit={onSubmit} noValidate>
      <div className="bg-white m-2 rounded p-2 px-2 md:p-4">
        <div className="grid gap-4 gap-y-2 text-sm grid-cols-1">
          {children}
        </div>
      </div>
    </form>
  );
};
